
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://vjrredluydfrknkcclbw.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZqcnJlZGx1eWRmcmtua2NjbGJ3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzkwNTc2OTcsImV4cCI6MjA1NDYzMzY5N30.oGrth4PAb73v802SGVTVznyIDiVt1-hYA0EwhE2mOq0";

// Initialize Supabase client

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  db: {
    schema: 'public'
  },
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'implicit' // Added to handle authentication flow type
  },
  global: {
    headers: {
      'apikey': SUPABASE_PUBLISHABLE_KEY
    }
  }
});

// Verify the client was created correctly
const isClientInitialized = !!supabase && !!supabase.auth && !!supabase.from;

// Auto-authenticate for development purposes
const autoAuthenticate = async () => {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    // Silent authentication check for development
  } catch (error) {
    console.error('Auth check failed:', error);
  }
};

// Execute auto-authentication
autoAuthenticate();

// Re-export core client and constants for use in other modules
export { SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY };
